import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import RegionForm from "../../components/RegionForm/RegionForm";
import useCreateRegion from "../../hooks/useCreateRegion";
import { adaptRegionPayload } from "../../adapters/adaptRegionPayload";

const BACK_PATH = "/users/locations";

const EMPTY_DEFAULTS: RegionFormValues = {
	name: "",
	regionManager: ""
};

const CreateRegion = () => {
	const navigate = useNavigate();
	const { mutate: createRegion, isLoading } = useCreateRegion();

	const handleSubmit = (values: RegionFormValues) => {
		const payload = adaptRegionPayload(values);

		createRegion(payload, {
			onSuccess: () => navigate(BACK_PATH)
		});
	};

	return (
		<Page>
			<RegionForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
				backPath={BACK_PATH}
			/>
		</Page>
	);
};

export default CreateRegion;
